import { Users } from "@phosphor-icons/react";

export default function Customers() {
  return (
    <div className="space-y-6 min-w-0" data-testid="customers-page">
      <div>
        <div className="eyebrow mb-1">Customers</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Your buyers</h1>
        <p className="text-muted-foreground mt-2 text-sm">Unified customer records synced from every connected marketplace.</p>
      </div>
      <div className="card-base p-12 text-center">
        <div className="w-16 h-16 rounded-full bg-orange/10 flex items-center justify-center mx-auto mb-5">
          <Users size={28} weight="duotone" className="text-orange"/>
        </div>
        <h3 className="font-display font-semibold text-xl text-navy mb-2">Coming in Phase 3</h3>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Customer profiles across marketplaces with order history and lifetime value.
        </p>
      </div>
    </div>
  );
}
